import React, { useEffect, useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.js",
    import.meta.url
  ).toString();
  
export type PDFBase64 = string;

interface PDFViewerProps {
  cvData: PDFBase64; 
}
export default function PreviewPdf({ cvData }: PDFViewerProps) {
    const [numPages, setNumPages] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
  
    const A4Width = 900; 
  
    const maxWidth = Math.min(window.innerWidth * 1.2, A4Width);
  
    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
      setNumPages(numPages);
    };
  
    const handleScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
      const { scrollTop, clientHeight } = e.currentTarget;
      const currentPage = Math.ceil(scrollTop / clientHeight) + 1;
      if (currentPage <= numPages && currentPage !== pageNumber) {
        setPageNumber(currentPage);
      }
    };
  
    useEffect(() => {
      setPageNumber(1);
    }, [cvData]);
  
    return (
      <div className="relative"  onScroll={handleScroll}>
        {cvData && (
          <div className="pdf-viewer max-h-[1150px] overflow-y-scroll px-8">
            <Document
              file={cvData}
              onLoadSuccess={onDocumentLoadSuccess}
              className="my-4"
            >
              {Array.from({ length: numPages }, (_, index) => (
                <Page
                  key={index}
                  pageNumber={index + 1}
                  width={maxWidth}
                  renderTextLayer={false} 
                  renderAnnotationLayer={false} 
                />
              ))}
            </Document>
          </div>
        )}
      </div>
    );
  }